export default __webpack_public_path__ + "static/media/elemento01_web.60eb92dc.png";